import ReactDOM from "react-dom";
import React from "react";
import Prospective from "../components/fund-medication-listing/Prospective";

const init = () => {
  let mountPoint = document.querySelector("#FundListing");

  if (mountPoint) {
    ReactDOM.render(<Prospective />, mountPoint);
  }
};

// Init on initial page load
init();

